// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2h4lw","additionalInfo":"AgreementModal_additionalInfo__1xRCW"};